import { getInvoicesUrl } from './InsertInvoices';
import ContentPopoverEmptyState from '../../../draft-content-transplant/ContentPopoverEmptyState';
import { jsx as _jsx } from "react/jsx-runtime";
const InvoicesPopoverEmptyState = () => /*#__PURE__*/_jsx(ContentPopoverEmptyState, {
  image: "invoices",
  title: "hubspot-prosemirror.invoices.popover.emptyState.title",
  description: "hubspot-prosemirror.invoices.popover.emptyState.description",
  buttonLabel: "hubspot-prosemirror.invoices.popover.emptyState.buttonLabel",
  buttonLink: getInvoicesUrl()
});
export default InvoicesPopoverEmptyState;